import { memo, useMemo } from "react";
import { useParams } from "react-router-dom"; // 1. Import useParamsimport Breadcrumbs from "components/common/Breadcrumbs";
import ROUTE_PATHS from "constants/routePaths";
import useSinglePhase from "hookQueries/useSinglePhase";
import Breadcrumbs from "components/common/Breadcrumbs";

function PhaseRuleBreadcrumbs() {
  const { id } = useParams();
  const { data } = useSinglePhase();
  const campaignName = data?.name;
  const breadcrumbs = useMemo(() => {
    const deployPath = id ? `/admin/phase/deploy/${id}` : ROUTE_PATHS.admin;
    const deployBreadcrumb = { label: "Deploy", path: deployPath };

    if (!campaignName) return [deployBreadcrumb];

    return [deployBreadcrumb, { label: campaignName }];
  }, [campaignName, id]);

  return <Breadcrumbs breadcrumbs={breadcrumbs} />;
}

export default memo(PhaseRuleBreadcrumbs);
